module.exports = __webpack_public_path__ + "static/VideoJuliánBonillasub-9d7b0191ea98aadb02c0d2b6eb2ba5ac.mp4";